// extracted by mini-css-extract-plugin
export default {"errorMessage":"GmailWidget_errorMessage__cE0ZR","statusBadge":"GmailWidget_statusBadge__ChCRw","warningIcon":"GmailWidget_warningIcon__iceF5","text":"GmailWidget_text__xON5T"};